<template lang="pug">
  div.wrap-atom-tool-animation-selector
    v-menu(offset-x)
      template(v-slot:activator="{ on }")
        div(:class="`doodle-animation-${currentAnimation}`").wrap-current-animation
          v-icon(v-on="on" size="20px" color="#fff") mdi-alpha-a-box
      template
        div.doodle-animation-selector.f.fm.px4.py4
          div(v-for="item in animations"
            :class="`doodle-animation-${item}`").wrap-icon.mb8
            v-icon(@click="currentAnimation = item" color="#fff") mdi-alpha-a-box
</template>

<style lang="scss" scoped>
.wrap-atom-tool-animation-selector {
  .wrap-current-animation {
    border-radius: 3px;
    background: rgba(0, 0, 0, 0.6);
  }
}
</style>

<style lang="scss">
@import "@/scss/_variables.scss";
@import "@/scss/doodleAnimation.scss";

.doodle-animation-selector {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.6);
}
</style>

<script>

export default {
  props: {
    // data: {
    //   type: Object,
    //   required: true
    // }
  },
  data () {
    return {
      currentAnimation: 'normal',
      animations: [
        'normal', 'rotation', 'scaling', 'breathing',
        'jumping', 'fuwafuwa', 'kurukuru',
      ]
    }
  },
  watch: {
    currentAnimation () {
      this.$emit('setCurrentAnimation', this.currentAnimation)
    }
  },
  methods: {
    getCurrentAnimation () {
      return this.currentAnimation
    }
  }
}
</script>
